<template>
    <div v-if="loading">
        <i class="fal fa-spinner fa-spin" /> Attribute List Data Loading...
    </div>
    <div v-else>
        <h1>Child Attributes</h1>
        <b-tabs>
            <div v-if="!haveBody" class="text-center my-5 font-2xl text-muted">
                <i class="fal fa-spinner fa-spin" /> Loading Related...
            </div>
            <div v-else class="animated">
                <b-tab v-for="unique in managedLists" :key="unique[0]" :title="`${unique[1][0].description}`">
                    <div class="float-right mb-2">
                        <header-button-group :button_config="attribute_button_config" :link_context="unique[0]" />
                    </div>
                    <AttributesListTable :related="getChildrenFiltered(unique[0])" :managedLists="unique[1]" />
                </b-tab>
            </div>
        </b-tabs>
    </div>
</template>
<script>
import ManagedListCollection from '@/collections/lab/ManagedListCollection';
import AttributesListTable from './table/AttributesListTable.vue';
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
    name: "AttributesListRelatedTabs",
    components: {
        AttributesListTable,
        HeaderButtonGroup
    },
    props: {
        attribute: {
            type: Object,
            default: () => null,
        },
    },
    computed: {
        attribute_button_config() {
            return {
                buttons: [
                {
                    icon: "fa-plus",
                    linkto: "/attributes-lists/add",
                    title: "Add New Attribute",
                    text: "Add Attribute",
                    variant: "success",
                    permission: this.checkPermission("add attribute list"),
                },
                ],
            };
        },
    },
    data() {
        return {
            // All the children that the attribute list has
            attributeChildren: this.attribute.children,
            // a list that will contain the managed list the children are related to
            managedLists: new Map(),
            loading: true,
            haveBody: false,
        };
    },
    methods: {
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        },
        async init() {
            this.getUniqueManagedListId();
            this.updateManagedListMap();
        },
        updateManagedListMap() {
            let itr = 0;
            this.managedLists.forEach((key) => {
                this.getManagedList(key).then((res) => {
                    this.managedLists.set(key, res[0]);
                    itr += 1;
                    // once the itr and the size of the managed list are the same
                    // we know we have everything and can just quit + display the tables
                    if (itr === this.managedLists.size) {
                        this.haveBody = true;
                        return;
                    }
                });
            });
        },
        getUniqueManagedListId() {
            // for each of the children, fill out the inital map with the managed list id
            // This is done to keep only fetch unique managed lists
            // In the case when a sinlge managed lists belongs to many attribute lists we only have to do one fetch
            this.attributeChildren.forEach(async (child) => {
                this.managedLists.set(child.managed_list_id, child.managed_list_id);
            });
        },
        async getManagedList(id) {
            const fetches = [];
            const list = new ManagedListCollection();
            const Filter = list.getFilter();
            Filter.filterEquals("id", id);
            
            fetches.push(
                list.fetch().then(({ response }) => {
                    if (response && response.status === 200 && response.data) {
                        return response.data.data;
                    }
                })
            );

            return Promise.all(fetches);
        },
        getChildrenFiltered(filterId) {
            return this.attributeChildren.filter((child) => child.managed_list_id === filterId);
        },
    },
    mounted() {
        this.init()
            .finally(() => this.loading = false);
    }
};
</script>